import { FoaPart } from "../../../../../autogen/bff-api";

export interface FoaPartBanner {
  messageKey: string;
  status: "info" | "warning";
}

// Mirrors the BFF's FoaPartClassifier.kt thresholds — keep in sync.
export const OUTSIDE_FOA_THRESHOLD_NOK = 500_000;
export const NATIONAL_THRESHOLD_NOK = 1_300_000;

export const isOutsideFoa = (estimatedValueNok: number | null | undefined): boolean =>
  estimatedValueNok != null && estimatedValueNok < OUTSIDE_FOA_THRESHOLD_NOK;

// Banner copy is consumed via a dynamic t(banner.messageKey) call, so langen can't see it.
// These magic comments register the keys statically — keep them verbatim with the switch below.
// t('This procurement is below the Procurement Act threshold — it should run in the simplified flow')
// t('This is a Del I procurement — it should run in the simplified flow')
// t('FOA Part II — national procurement, announced on Doffin')
// t('FOA Part III — over the EEA threshold, announced on Doffin and TED')
// t('FOA Part IV — special services')
// t('Over the national threshold — a public procurement announced on Doffin')
export const foaPartBanner = (
  foaPart: FoaPart | null | undefined,
  estimatedValueNok?: number | null,
): FoaPartBanner | null => {
  if (foaPart != null) {
    switch (foaPart) {
      case FoaPart.OutsideFoa:
        return { messageKey: "This procurement is below the Procurement Act threshold — it should run in the simplified flow", status: "info" };
      case FoaPart.PartI:
        return { messageKey: "This is a Del I procurement — it should run in the simplified flow", status: "info" };
      case FoaPart.PartIi:
        return { messageKey: "FOA Part II — national procurement, announced on Doffin", status: "info" };
      case FoaPart.PartIii:
        return { messageKey: "FOA Part III — over the EEA threshold, announced on Doffin and TED", status: "info" };
      case FoaPart.PartIv:
        return { messageKey: "FOA Part IV — special services", status: "info" };
      default: {
        const _exhaustive: never = foaPart;
        return _exhaustive;
      }
    }
  }
  if (estimatedValueNok != null && estimatedValueNok >= NATIONAL_THRESHOLD_NOK) {
    return {
      messageKey: "Over the national threshold — a public procurement announced on Doffin",
      status: "info",
    };
  }
  return null;
};

